import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TooltipDirective } from '@mode/capra';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, TooltipDirective],
  selector: 'mode-email-setting',
  templateUrl: './email-setting.component.html',
  styleUrls: ['./email-setting.component.scss'],
})
export class EmailSettingComponent {
  @Input() id = 'not-set';
  @Input() selected = false;
  @Input() isDisabled = false;
  @Input() disabledByWorkspaceSetting = false;

  @Output() selectedChange = new EventEmitter();
}
